import { cloneElement, isValidElement, useId } from "react";

export default function FormField({ label, required, error, hint, children, className = "" }) {
  const id = useId();
  const control = isValidElement(children)
    ? cloneElement(children, {
        id: children.props.id || id,
        "aria-invalid": error ? true : undefined,
        "aria-describedby": error || hint ? `${id}-msg` : undefined,
        className: `${children.props.className || "form-control"}${error ? " has-error" : ""}`,
      })
    : children;
  return (
    <div className={`form-field ${className}`}>
      {label && (
        <label className="form-label" htmlFor={children?.props?.id || id}>
          {label}
          {required && <span className="req" aria-hidden="true"> *</span>}
        </label>
      )}
      {control}
      {(error || hint) && (
        <p id={`${id}-msg`} className={error ? "form-error" : "form-hint"}>{error || hint}</p>
      )}
    </div>
  );
}
